import PlaceHolder from './place-holder'
export default PlaceHolder



// WEBPACK FOOTER //
// ./src/components/place-holder/index.js